import queryString from 'query-string';
import { get, post, remove, vdbsApi, vdbsPublicApi } from '../utilities/apiUtilities';
import { ANONYMOUS_REGULATION_TABLE, STATION_TABLE, CURRENCY_TABLE, FUNCTION_LEVEL_TABLE, JOB_TITLE_TABLE } from '../constants/dataTableIds';

export const postDataTablesSearch = (params) => post({
  url: `${vdbsApi}/masterdata/search`,
  data: params
});

export const getDataTables = (params) => get({
  url: `${vdbsApi}/masterdata?${queryString.stringify({ limit: 25, offset: 0, ...params })}`
});

const isPublicTable = (tableId) => {
  // For local development, don't use public API - use regular authenticated API
  if (process.env.NODE_ENV === 'development') {
    return false;
  }

  return [
    ANONYMOUS_REGULATION_TABLE,
    STATION_TABLE,
    CURRENCY_TABLE,
    FUNCTION_LEVEL_TABLE,
    JOB_TITLE_TABLE
  ].includes(tableId);
};

export const getDataTable = (tableId) => {
  const baseUrl = isPublicTable(tableId) ? `${vdbsPublicApi}/vdbs/v1` : vdbsApi;
  return get({
    url: `${baseUrl}/masterdata/${tableId}`
  });
};

export const getDataTableVersions = (tableId) => get({
  url: `${vdbsApi}/masterdata/${tableId}/versions/active`
});

export const getDataTableVersion = (tableId, id) => get({
  url: `${vdbsApi}/masterdata/${tableId}/versions/${id}`
});

export const getDataTableAsofDate = (tableId, date) => {
  const baseUrl = isPublicTable(tableId) ? `${vdbsPublicApi}/vdbs/v1` : vdbsApi;
  return get({
    url: `${baseUrl}/masterdata/${tableId}/${date}`
  });
};

export const postDataTable = (data) => post({
  url: `${vdbsApi}/masterdata`,
  data
});

export const postDataTableVersion = (tableId, data) => post({
  url: `${vdbsApi}/masterdata/${tableId}`,
  data
});

export const deleteDataTable = (tableId) => remove({
  url: `${vdbsApi}/masterdata/${tableId}`
});

export const postDataTableVersionApprove = (tableId, id) => post({
  url: `${vdbsApi}/masterdata/${tableId}/versions/${id}/approve`,
});

export const postDataTableVersionReject = (tableId, id, data) => post({
  url: `${vdbsApi}/masterdata/${tableId}/versions/${id}/reject`,
  data
});

export const postDataTableVersionRevoke = (tableId, id) => post({
  url: `${vdbsApi}/masterdata/${tableId}/versions/${id}/revoke`
});

export const postDataTableVersionAssign = (tableId, id, data) => post({
  url: `${vdbsApi}/masterdata/${tableId}/versions/${id}/review`,
  data
});
